module.exports = __webpack_public_path__ + "assets/8a30a1cf7a82ec760b66859d1db50203.png";